import { createSetPropMutation, createClearPropMutation } from '@/store/utils';
import * as types from '@/store/statistics/mutationTypes';

export default {
  [types.SET_GENERAL_STATISTICS]: createSetPropMutation('generalStatistics', {}),
  [types.CLEAR_GENERAL_STATISTICS]: createClearPropMutation('generalStatistics', {}),
  [types.SET_RECALCULATION_IN_PROGRESS]: createSetPropMutation('recalculationInProgress', []),
  [types.CLEAR_RECALCULATION_IN_PROGRESS]: createClearPropMutation('recalculationInProgress', []),
  [types.SET_PROJECT_STATISTICS]: createSetPropMutation('projectStatistics', {}),
  [types.CLEAR_PROJECT_STATISTICS]: createClearPropMutation('projectStatistics', {}),
  [types.SET_CLOUD_SERVICES_STATISTICS]: createSetPropMutation('cloudServicesStatistics', {}),
  [types.CLEAR_CLOUD_SERVICES_STATISTICS]: createClearPropMutation('cloudServicesStatistics', {}),
  [types.SET_PASSIVE_RISK_SCORE]: createSetPropMutation('passiveRiskScore', {}),
  [types.CLEAR_PASSIVE_RISK_SCORE]: createClearPropMutation('passiveRiskScore', {}),
};
